import useAlert from '@/hooks/useAlert';
import CommonError from './CommonError';
import useMountEffect from '@/hooks/react/useMountEffect';

const BridgeError = () => {
  const alert = useAlert();

  useMountEffect(() => {
    alert({
      title: `이벤트 참여를 위해\n앱 업데이트를 해주세요`,
      description: '원활한 이벤트 참여를 위해 최신의 앱이 필요해요',
    });
  });

  return <CommonError />;
};

export default BridgeError;
